// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.compare-toggle {
  margin-top: 8px;
}
.compare-toggle .compare-btn {
  font-size: 0.8rem;
  padding: 4px 14px;
  height: 32px;
  line-height: 30px;
  color: #0066b2;
  border-color: #0066b2;
}
.compare-toggle .compare-btn mat-icon {
  font-size: 1rem;
  width: 1rem;
  height: 1rem;
  line-height: 1rem;
  margin-right: 4px;
  vertical-align: middle;
}
.compare-toggle .compare-btn:hover:not([disabled]) {
  background-color: rgba(0, 102, 178, 0.06);
}
.compare-toggle .compare-btn.compare-active {
  background-color: rgba(0, 102, 178, 0.1);
  font-weight: 600;
}
.compare-toggle .compare-loading {
  margin-top: 4px;
  max-width: 200px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
